import { Features } from '../utility/features.constants';

export const Systems = Object.freeze({
    Portal: '',
    RDARR: 'RDARR',
    EWIS: 'EWIS',
    Indicators: 'Indicator Service',
    RiskAppetite: 'Risk Appetite',
    RiskCulture: 'Risk Culture',
});

export const SystemKeys = {
    [Systems.Portal]: Features.portal.key,
    [Systems.RDARR]: Features.rdarr.key,
    [Systems.EWIS]: Features.ewis.key,
    [Systems.Indicators]: Features.indicators.key,
    [Systems.RiskAppetite]: Features.riskAppetite.key,
    [Systems.RiskCulture]: Features.riskCulture.key,
};
